var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { del, get, post, put } from 'common/utils/request';
import { prepareParamsToQueryString } from 'common/helpers/prepare-params-to-query-string';
import { CHAT_URL } from 'common/constants/common';
var chatRequestSettings = { baseURL: CHAT_URL };
export var fetchChatMessagesApi = function (_a) {
    var chatId = _a.chatId, beforeSentAt = _a.beforeSentAt, messageTextFilter = _a.messageTextFilter, _b = _a.pageSize, pageSize = _b === void 0 ? 20 : _b;
    return get("/Chats/".concat(chatId, "/messages").concat(prepareParamsToQueryString({
        beforeSentAt: [beforeSentAt, true],
        messageTextFilter: [messageTextFilter, true],
        pageSize: pageSize,
    }, true)), {}, __assign({ abortRequestKey: 'chatFetchMessages' }, chatRequestSettings));
};
export var fetchUnreadMessagesCursorApi = function (_a) {
    var chatId = _a.chatId;
    return get("/Chats/".concat(chatId, "/messages/cursor"), {}, __assign({ abortRequestKey: 'chatFetchUnreadMessagesCursor' }, chatRequestSettings));
};
export var publishChatMessageApi = function (_a) {
    var chatId = _a.chatId, textMessage = _a.textMessage;
    return post("/Chats/".concat(chatId, "/messages"), { textMessage: textMessage }, chatRequestSettings);
};
export var editChatMessageApi = function (_a) {
    var chatId = _a.chatId, messageId = _a.messageId, newTextMessage = _a.newTextMessage;
    return put("/Chats/".concat(chatId, "/messages/").concat(messageId), { newTextMessage: newTextMessage }, chatRequestSettings);
};
export var markChatMessagesAsReadApi = function (_a) {
    var chatId = _a.chatId, readAt = _a.readAt;
    return put("/Chats/".concat(chatId, "/messages/cursor"), { readAt: readAt }, chatRequestSettings);
};
export var deleteChatMessageApi = function (_a) {
    var chatId = _a.chatId, messageId = _a.messageId;
    return del("/Chats/".concat(chatId, "/messages/").concat(messageId), {}, chatRequestSettings);
};
